import React from "react";
import {
  formatDateForDisplay,
  formatDateTimeForDisplay,
} from "../../utils/patient/patientUtils";

const cardStyle = {
  border: "1px solid #e5e7eb",
  borderRadius: 14,
  padding: 12,
  background: "#fff",
};

const buttonStyle = {
  border: "1px solid #cbd5e1",
  borderRadius: 10,
  padding: "8px 12px",
  background: "#fff",
  cursor: "pointer",
};

export default function DuplicateMatchPanel({
  matches = [],
  onOpenPatient,
  onUseExistingPatient,
}) {
  if (!matches.length) return null;

  return (
    <div
      style={{
        marginTop: 14,
        padding: 14,
        borderRadius: 16,
        border: "1px solid #f59e0b",
        background: "#fffbeb",
      }}
    >
      <div style={{ fontWeight: 700, marginBottom: 6 }}>Possible existing patients found</div>
      <div style={{ color: "#92400e", marginBottom: 12 }}>
        Open one of these instead of creating a duplicate, or use an existing patient and start a
        new encounter.
      </div>

      <div style={{ display: "grid", gap: 10 }}>
        {matches.map((patient) => (
          <div key={patient.id} style={cardStyle}>
            <div style={{ fontWeight: 700 }}>{patient.fullName || "Unnamed patient"}</div>
            <div style={{ color: "#64748b", fontSize: 14, marginTop: 4 }}>
              DOB: {patient.dob || "—"} · Phone: {patient.phone || "—"}
            </div>
            <div style={{ color: "#64748b", fontSize: 14, marginTop: 4 }}>
              Last seen: {formatDateTimeForDisplay(patient.lastEncounterAt || patient.updatedAt)}
            </div>
            <div style={{ color: "#64748b", fontSize: 14, marginTop: 4 }}>
              Created: {formatDateForDisplay(patient.createdAt)}
            </div>

            <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 12 }}>
              <button style={buttonStyle} type="button" onClick={() => onOpenPatient(patient)}>
                Open Patient
              </button>
              <button
                style={buttonStyle}
                type="button"
                onClick={() => onUseExistingPatient(patient)}
              >
                Use Existing + New Encounter
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}